import mapboxgl from 'mapbox-gl';
import history from '../utils/history.js';

export default class MapModule {
    constructor() {
        this.map = null;
        this.mapdata = [];

        this.generateMapData();
        this.$postsWrapper = $('.map__storys-wrap');
        this.$postsContainer = this.$postsWrapper.find('.item-wrap');
    }

    getUrlParameter(sParam) {
        let sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };

    getMapCenter() {
        let centerCoords = {
            large: [2.918285, 54.537845].join(','),
            small: [-1.918285, 52.537845].join(','),
        };

        centerCoords = history.get('map-center', $(window).width() > 960 ? centerCoords['large'] : centerCoords['small']);

        return centerCoords.split(',');
    }

    mapInit() {
        if (!$('#newMap').length) {
            return;
        }
        mapboxgl.accessToken = 'pk.eyJ1IjoiYWxleGFuZHJpYW53aXRjaGNyYWZ0IiwiYSI6ImNqZ3hoemhibzA1eHIzM3F4MDJwbHd2ZDgifQ.l-FAxKmImbt2feH41XcTtw';


        this.map = new mapboxgl.Map({
            container: 'newMap',
            style: 'mapbox://styles/alexandrianwitchcraft/cjgxj4iv0003a2sqp5480wyk7',
            center: this.getMapCenter(),
            zoom: history.get('map-zoom', 5.01),
        });

        this.map.on('load', this.mapLoad.bind(this));

        this.map.on('moveend', this.mapMoved.bind(this));
        this.map.on('zooomend', this.mapMoved.bind(this));

        $(window).on('resize', () => this.map.resize());
    }

    mapMoved(e) {
        const center = this.map.getCenter();

        history.set({
            'map-zoom': Math.round(this.map.getZoom() * 10) / 10,
            'map-center': center.toArray().join(',')
        });
    }

    mapLoad(e) {
        const mapData = {
            'type': 'FeatureCollection',
            'features': this.mapdata
        };

        this.map.addSource('alexandrian-locations', {
            type: 'geojson',
            data: mapData,
            cluster: true,
            clusterMaxZoom: 14,
            clusterRadius: 50,
            generateId: true,
        });

        this.addPoints();
        this.addPointEvents();
        this.loadLocationBasedPins();
    }

    ajaxGetPosts(params, cb) {
        const callbacks = $.extend({}, {
            always: $.noop,
            success: $.noop
        }, cb);

        if (this.ajaxGetPostsCall) {
            this.ajaxGetPostsCall.abort();
        }


        this.ajaxGetPostsCall = $.ajax({
            type: 'POST',
            dataType: "json",
            url: alexandrian_wicca.ajaxurl,

            data: $.extend({}, {
                action: "get_posts_list",
                date_range: this.getUrlParameter('date_selected'),
                post_ids: [],
                coords: {},
                zoom: null
            }, params),

            complete: () => {
                $('body').removeClass('is-home-search-loading');
                callbacks.always();
            },

            success: (res) => {
                const numberOfArticles = $('.number-articles');
                numberOfArticles.html('');
                numberOfArticles.html(res.post_count);

                this.showPosts(res);

                $('body').addClass('is-home-search-visible');

                callbacks.success(res);
            }
        });
    }

    ajaxGetPostsByIds(ids, cb = {}) {
        this.ajaxGetPosts({
            "post_ids": ids,
        }, cb);

        history.set({
            ids: ids.join(',')
        });
    }

    showPosts(res) {
        this.$postsWrapper.hide();
        this.$postsContainer.html('');

        res.posts.forEach((item) => {
            item.has_images = !!item.image;
            item.has_videos = !!item.video;
            item.has_audio = !!item.audio;
            item.has_pdf = !!item.pdf;
            item.has_anecdote = !!(item.anecdote_img || item.anecdote_text);

            const tpl = _.template($('#search-results-tpl').html());

            this.$postsContainer.append(tpl({
                item: item
            }));
        });

        this.$postsWrapper.show();
        this.showViewAllBtn(res);
    }

    showViewAllBtn(res) {
        const $btn = $('.home-btn');
        let scrollContainer = null;
        const initScroll = () => {
            this.$postsContainer.getNiceScroll().remove();
            scrollContainer = this.$postsContainer.niceScroll({
                cursorcolor: 'rgba(255,255,255,0.5)',
                cursorwidth: '14px',
                background: 'rgba(255,255,255,0.3)',
                cursorborderradius: 0
            });
        };

        initScroll();
        if (res.post_count < 10) {
            $btn.removeClass('show');
        } else {
            $btn.removeClass('show');
            $btn.addClass('show');
            $btn.find('a').attr('href', res.href);
        }
    }

    maybeOpenResults() {
        const ids = history.get('ids');
        let center = this.getMapCenter();

        if (ids.length) {
            this.showLoadingIndicator(new mapboxgl.LngLat(center[0], center[1]));
            this.ajaxGetPostsByIds(ids.split(','), {
                always: () => this.loadingIndicator.remove()
            });
        }


        return;

        const bounds = new mapboxgl.LngLatBounds(
            new mapboxgl.LngLat(center[0] - 1, center[1] - 1),
            new mapboxgl.LngLat(center[0] + 1, center[1] + 1)
        );

        window.zz = bounds;

        center = new mapboxgl.LngLat(center[0], center[1]);

        const pointsInCluster = this.mapdata.filter((f) => {
            const point = this.map.unproject(f.geometry.coordinates);
        });
    }

    onMapPointClicked(point, e) {
        if (!point[0]) {
            return;
        }

        const articleInThisPins = [];

        this.map.flyTo({
            center: e.lngLat,
            speed: 0.2, // make the flying slow
            curve: 1, // change the speed at which it zooms out

            // This can be any easing function: it takes a number between
            // 0 and 1 and returns another number between 0 and 1.
            // https://gist.github.com/gre/1650294
            easing: t => t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t,

            // this animation is considered essential with respect to prefers-reduced-motion
            essential: true
        });

        const pointsInCluster = this.mapdata.filter((f) => {
            const pointPixels = this.map.project(f.geometry.coordinates);

            const pixelDistance = Math.sqrt(
                Math.pow(e.point.x - pointPixels.x, 2) +
                Math.pow(e.point.y - pointPixels.y, 2)
            );

            return Math.abs(pixelDistance) <= clusterRadius;
        });

        for (let i = 0; i < pointsInCluster.length; i++) {
            const pointPostId = (pointsInCluster[i].properties['map-articles-ids']);
            if (pointPostId.length >= 1) {
                for (let n = 0; n < pointPostId.length; n++) {
                    articleInThisPins.push(pointPostId[n]);
                }
            }
        }

        this.ajaxGetPostsByIds(articleInThisPins, {
            always: () => this.loadingIndicator.remove()
        });

        this.showLoadingIndicator(e.lngLat);
    }

    showLoadingIndicator(lngLat) {
        if (this.loadingIndicator) {
            this.loadingIndicator.remove();
        }

        this.loadingIndicator = new mapboxgl.Popup({
            closeOnClick: false,
            closeButton: false,
            closeOnMove: false,
            anchor: 'center',
            className: 'map-pointer-loading'
        })
            .setLngLat(lngLat)
            .setHTML('Loading')
            .addTo(this.map);
    }

    addPointEvents() {
        this.map.on('click', 'clusters', (e) => {
            const cluster = this.map.queryRenderedFeatures(e.point, {layers: ["clusters"]});
            this.onMapPointClicked(cluster, e);
        });

        this.map.on('click', 'unclustered-point', (e) => {
            const pins = this.map.queryRenderedFeatures(e.point, {layers: ["unclustered-point"]});
            this.onMapPointClicked(pins, e);
        });

        const changeCursorType = (e) => {
            this.map.getCanvas().style.cursor = e.type === 'mouseenter' ? 'pointer' : '';

        };

        this.map.on('mouseenter', 'unclustered-point', changeCursorType);
        this.map.on('mouseleave', 'unclustered-point', changeCursorType);
        this.map.on('mouseenter', 'clusters', changeCursorType);
        this.map.on('mouseleave', 'clusters', changeCursorType);
    }

    loadLocationBasedPins() {
        $('.js-home-location-pin').on('click', (e) => {
            const $target = $(e.currentTarget).addClass('is-loading');
            this.ajaxGetPostsByIds($target.data('ids'), {
                always: () => $target.removeClass('is-loading')
            });
        });
    }

    addPoints() {
        // https://docs.mapbox.com/help/tutorials/mapbox-gl-js-expressions/
        // https://docs.mapbox.com/mapbox-gl-js/style-spec/expressions/

        let variableClusterSize = [
            '*', 2,
            ['number', ['get', 'point_count'], 1]
        ];

        variableClusterSize = ['max', 16, variableClusterSize];
        variableClusterSize = ['min', variableClusterSize, 32];

        this.map.addLayer({
            id: "clusters",
            type: "circle",
            source: "alexandrian-locations",
            filter: ["has", "point_count"],

            paint: {
                "circle-color": "#b38200",
                'circle-opacity': 0.8,
                'circle-radius': variableClusterSize
            }
        });

        this.map.addLayer({
            id: "unclustered-point",
            type: "circle",
            source: "alexandrian-locations",
            filter: ["!", ["has", "point_count"]],
            paint: {
                "circle-color": "#b38200",
                "circle-radius": 14,
            },
        });

        const pointContent = (textField = "{point_count_abbreviated}") => {
            return {
                type: "symbol",
                source: "alexandrian-locations",
                paint: {
                    "text-color": "#fff"
                },

                layout: {
                    "text-field": textField,
                    "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
                    "text-size": 15
                }
            };
        };

        this.map.addLayer(
            $.extend({
                id: "cluster-count",
                filter: ["has", "point_count"],
            }, pointContent())
        );

        this.map.addLayer($.extend({
                id: "unclustered-count",
                filter: ["!", ["has", "point_count"]],
            }, pointContent('1'))
        );

        this.map.zoomTo(this.map.getZoom() + 0.001)
    }

    generateMapData() {
        const locations = window.postsLocations || [];

        locations.forEach((item) => {
            this.mapdata.push(this.createMapObject(item));
        });
    }

    createMapObject(data) {
        return {
            type: 'Feature',
            properties: {
                'map-point-text': data.articles,
                'map-articles-ids': data.articles_ids,
            },
            geometry: {
                type: 'Point',
                coordinates: [data.lng, data.lat]
            }
        }
    }

    init() {
        this.mapInit();
        this.maybeOpenResults();
    }
}
